export default __webpack_public_path__ + "static/M2-shop-1bd030b0fce583243c70cc919b6ffaf4.png";